export default [
    {
        path: "/futures",
        name: "live",
        redirect: '/futures/living',
        component: () => import("@/layout/index"),
        children: [
            {
                path: 'living',
                name: 'living', 
                redirect: '/futures/living/index',
                component: () => import("@/pages/v2/live/index"),
                children: [
                    {
                        path: 'index',
                        name: 'index',
                        component: () => import("@/pages/v2/live/live"),
                    },
                    {
                        path: 'class',
                        name: 'bkClassRoom',
                        component: () => import("@/pages/v2/live/bkClassRoom"),
                    },
                    {
                        path: 'replay',
                        name: 'replay',
                        component: () => import("@/pages/v2/live/bkClassRoom/replay"),
                    },
                    {
                        path: 'preview',
                        name: 'preview',
                        component: () => import("@/pages/v2/live/preview"),
                    },
                    {
                        path: 'apply',
                        name: 'apply',
                        component: () => import("@/pages/v2/live/applyLiving"),
                    },
                    {
                        path: 'living/record',
                        name: 'livingRecord',
                        component: () => import("@/pages/v2/live/live/livingRecord"),
                    },
                    {
                        path: 'start',
                        name: 'livingStart',
                        component: () => import("@/pages/v2/live/live/start"),
                    },
                    {
                        path: 'streamer',
                        name: 'Streamer',
                        component: () => import("@/pages/v2/live/live/streamer"),
                    },
                    {
                        path: 'apply/record',
                        name: 'applyRecord',
                        component: () => import("@/pages/v2/live/applyLiving/applyRecord"),
                    },
                ]
            },
            
        ],
    },
];



// WEBPACK FOOTER //
// ./src/router/v2/live/index.js